import React, { useState, useEffect } from "react";
import ApplicationContext from "./ApplicationContext";
import axios from "axios";
import { FORUM_SETTINGS_PUBLIC } from "../routes/routes";
import defaultLogo from "../assets/images/logo.png";

function applyFavicon(url) {
  if (!url || typeof document === "undefined") return;
  const links = document.querySelectorAll("link[rel*='icon']");
  if (links.length) {
    links.forEach((link) => {
      link.href = url;
    });
  } else {
    const link = document.createElement("link");
    link.rel = "icon";
    link.href = url;
    document.head.appendChild(link);
  }
}

const ApplicationProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [permissions, setPermissions] = useState(() => {
    const savedPermissions = localStorage.getItem("permissions");
    return savedPermissions ? JSON.parse(savedPermissions) : [];
  });

  const [forumLogo, setForumLogo] = useState(defaultLogo);
  const [forumFavicon, setForumFavicon] = useState("");

  const setUserAndPermissions = (userData, userPermissions) => {
    setUser(userData);
    setPermissions(userPermissions);
  };

  const refreshForumBranding = () => {
    return axios
      .get(FORUM_SETTINGS_PUBLIC)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          const data = res.data.data || {};
          if (data.forum_logo?.content && data.forum_logo?.url) {
            setForumLogo(data.forum_logo.url);
          } else {
            setForumLogo(defaultLogo);
          }
          if (data.forum_favicon?.content && data.forum_favicon?.url) {
            setForumFavicon(data.forum_favicon.url);
            applyFavicon(data.forum_favicon.url);
          }
        }
      })
      .catch(() => {
        /* keep defaults */
      });
  };

  useEffect(() => {
    refreshForumBranding();
  }, []);

  return (
    <ApplicationContext.Provider
      value={{
        user,
        permissions,
        setUserAndPermissions,
        auth: !!user,
        forumLogo,
        forumFavicon,
        refreshForumBranding,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};

export default ApplicationProvider;
